<div class="product-item" (click)="onSeeTicketSoldInfo()">
  <img class="icon" [src]="icon" alt="product icon" />
  <div class="product-info">
    <p class="product-name">{{ product.name }}</p>
    <p class="product-category">
      {{ "products.category" | translate }} {{ product.category }}
    </p>
    <div class="product-meta">
      <span class="product-price">
        {{ product.price | arsCurrency }}
      </span>
      <span class="product-sold">
        <img src="assets/icons/ticket-icon.svg" class="ticket-icon" />
        <span>
          {{ product.total_tickets_by_seller }}
          {{ "products.ticketSold" | translate }}
        </span>
      </span>
    </div>
  </div>

  <div
    class="dropdown-button"
    (click)="$event.stopPropagation(); openProductOptionsModal()"
  >
    <ion-icon name="ellipsis-vertical" class="options-icon" />
  </div>
</div>
